module.exports = __webpack_public_path__ + "img/jimeng_1.9a8ac80f.png";